import { Injectable } from '@angular/core';
import {
  IGetIzvodTableQuery,
  UplateIsplateSummaryDto,
} from '@kodit/core/data-api';
import { AdvancedFilterActionData } from '@kodit/core/shared-ui';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IzvodFilterService {
  constructor() {}

  /**
   * Advanced filter methods
   */
  advanceFilterSubmitted$ = new BehaviorSubject<
    AdvancedFilterActionData<IGetIzvodTableQuery>
  >(null);
  get getAdvanceFilterSubmitted() {
    return this.advanceFilterSubmitted$.asObservable();
  }
  set setAdvanceFilterSubmitted(
    data: AdvancedFilterActionData<IGetIzvodTableQuery>
  ) {
    this.advanceFilterSubmitted$.next(data);
  }

  
}
